import React, { useEffect, useState } from 'react'; //useCallback
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
// import { useAuthenticator } from '@aws-amplify/ui-react'; //, Flex, Heading,Text,StepperField
import PropTypes from 'prop-types';
import SoftButton from '../../components/SoftButton/index';
import SoftBox from '../../components/SoftBox';
import SoftTypography from '../../components/SoftTypography';
import SoftInput from '../../components/SoftInput';
import SoftBadge from '../../components/SoftBadge';
import Dialog from '../../components/Dialog';
import { exportToExcel } from '../../components/ExportExcel';
import { sendMail } from '../../scripts/lambda';
import { getCompany } from '../../scripts';
import { createOverseasOrder, updateOverseasOrder } from '../../scripts/mutations';
import { listShippings, getOrder } from '../../scripts';
import Icon from '@mui/material/Icon';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import { Box, TextField, Autocomplete } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Grid from '@mui/material/Grid';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';

const initialState = { code: [], name: '', qty: 0, amount: 0, status: [], orderType: 'TW' };
const steps = ['Create', 'Review', 'Done'];
Modal.setAppElement('#root');

const Order = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { t } = useTranslation();
	const [formState, updateFormState] = useState(initialState);
	const area = useSelector((state) => state.user.userArea);
	const getname = useSelector((state) => state.user.userName);
	// const email = useSelector((state) => state.user.userEmail);
	const role = useSelector((state) => state.user.userRole);
	const [inv, updateItem] = useState([]);
	const [qtyVal, updateVal] = useState([]);
	const [tabValue, setTabValue] = useState(0);
	const [activeStep, setActiveStep] = useState(0);
	const [curQty, setCurQty] = useState(0);
	const [curArea, setCurArea] = useState(area[0]);
	const [curCount, setCurCount] = useState(0);
	const [curCBM, setCBM] = useState(0);
	const [finalAmount, setFinalAmount] = useState(0);
	const [catCount, setCatCount] = useState({});
	const [catAmount, setCatAmount] = useState({});
	const [catQty, setCatQty] = useState({});
	const [currency, setCurrency] = useState('');
	const [input, setInput] = useState('');
	const [company, setCompany] = useState([]);
	const [companyEmail, setCompanyEmail] = useState([]);
	const [dialog, setDialog] = useState(false);
	const [dTitle, setDTitle] = useState('');
	const [dContent, setDContent] = useState('');

	useEffect(() => {
		if (location.state) {
			let stateArea = location.state[0].orderarea;
			setCurArea(stateArea);
			getItem(stateArea);
			if (stateArea === 'CA_Rosin-International-Enterprises-LTD') {
				setCurrency('TWD');
			} else {
				setCurrency('USD');
			}
		} else if (area.length > 0) {
			setCurArea(area[0]);
			getItem(area[0]);
			if (area[0] === 'CA_Rosin-International-Enterprises-LTD') {
				setCurrency('TWD');
			} else {
				setCurrency('USD');
			}
		}
		getCompany().then((i) => {
			let company = {};
			let email = {};
			Object.keys(i).map((key) =>
				!key.includes('/') ? (company[key] = i[key]) : key.includes('Email') ? (email[key.split('/')[0]] = i[key]) : ''
			);
			setCompany(company);
			setCompanyEmail(email);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [area]);

	const handleChange = (event, newArea) => {
		if (newArea !== null) {
			setCurArea(newArea);
			if (newArea === 'CA_Rosin-International-Enterprises-LTD') {
				setCurrency('TWD');
			} else {
				setCurrency('USD');
			}
			getItem(newArea);
		}
	};

	const handleDialog = (e, title, src) => {
		e.preventDefault();
		if (dialog) {
			setDialog(false);
			setDTitle('');
			setDContent('');
		} else if (title) {
			setDTitle(title);
			setDContent(
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<img src={src} width="70%" height="70%" alt={title} />
				</div>
			);
			setDialog(true);
		}
	};

	const handleSetTabValue = (event, newValue) => setTabValue(newValue);

	const handleNext = () => {
		if (activeStep === 0) {
			submit();
		}
		if (activeStep === 1) {
			createOrder();
		}
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleOpening = () => {
		if (tabValue === 6) {
			let el = document.getElementById('f4c531ec-c92f-468a-9ea5-d1fc5f7fbcbd');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('db8a7951-b7fc-4fc4-88c0-5ec3848ad3b0');
			if (el) {
				el.focus();
				el.value = 10;
			}
			el = document.getElementById('879132b8-87e9-4343-a156-f99ffd8de379');
			if (el) {
				el.focus();
				el.value = 8;
			}
			el = document.getElementById('65cb6435-ecc6-452b-9658-f2e546a0f49f');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('8e3dea5d-b64b-4c13-971f-2b0003955a85');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('1c83253c-7447-401b-910a-685079bf18a6');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('cdbd95f8-b231-4385-9c0a-1c92434fb9b3');
			if (el) {
				el.focus();
				el.value = 16;
			}
			el = document.getElementById('300e2304-a3a7-48ee-8fdc-5f46827610c0');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('09ecdd14-33af-4710-ab68-7f939082ab1a');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('56bf277c-bd4e-43f7-a6de-4a8f02e12348');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('737fc3e6-e560-4a54-8d65-069d4024b16e');
			if (el) {
				el.focus();
				el.value = 3;
			}
			el = document.getElementById('cc11b5c8-86fb-41c3-bcfe-e86b6cda3fd3');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('0b3e5061-4723-4633-aa6a-1cc7b1131c2f');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('ce1217f7-ac51-4750-a372-4acc64a36398');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('2a42cc31-da37-4858-a48b-25ac3061934b');
			if (el) {
				el.focus();
				el.value = 15;
			}
			el = document.getElementById('6b173e8e-8a7c-496a-99ac-b0bf7c3b6b98');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('bcb0a6cf-d93a-4bec-a57b-21b2a8cd8452');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('289ed7e3-106f-4386-b0ce-38985d24211a');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('06be8b51-f657-4c07-a529-5f310b95bb57');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('22cb18cc-d204-405d-8e04-6205138b2281');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('d95e7470-dd08-4e1f-ab85-0ec4de3b9ef7');
			if (el) {
				el.focus();
				el.value = 3;
			}
			el = document.getElementById('ee7235f9-0e7b-40ab-a53d-1983a0ce273b');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('d7ddf919-ce1b-4d64-99ba-7dd26fc375d9');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('f3522871-71c6-4cc8-8b16-b9e07f268273');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('17c3eda1-4e15-4267-913d-51ad96726750');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('e72aec49-3423-479a-9c8f-95783112baab');
			if (el) {
				el.focus();
				el.value = 8;
			}
			el = document.getElementById('6b5f5c20-c851-4117-8f38-7b3609f22403');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('8c7d6582-d9a6-47fa-8f6f-060f39a326f3');
			if (el) {
				el.focus();
				el.value = 5;
			}
			el = document.getElementById('5a387fc6-882d-41b8-b6a6-4fb84adebd40');
			if (el) {
				el.focus();
				el.value = 8;
			}
			el = document.getElementById('d7a9c6af-aa3f-4865-bfb8-06c154b6eac6');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('38f3dcc0-74e0-4fd4-94c3-7dbd894bcdfe');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('31db4359-658c-4070-b178-f42167228636');
			if (el) {
				el.focus();
				el.value = 3;
			}
			el = document.getElementById('9eab591d-0029-4b4c-9b6a-3dbff0be6b03');
			if (el) {
				el.focus();
				el.value = 10;
			}
			el = document.getElementById('6fe1652b-fd6f-438e-86b1-56fe182c72d2');
			if (el) {
				el.focus();
				el.value = 8;
			}
			el = document.getElementById('ba840d47-bef7-4322-b626-822d4506c0aa');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('56c8649a-79b8-4f88-a175-d1294d02c9cc');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('f6ef3552-92eb-4a35-b858-c9dfa1c53be6');
			if (el) {
				el.focus();
				el.value = 8;
			}
			el = document.getElementById('98e6d672-9896-439a-9c3a-88df40288957');
			if (el) {
				el.focus();
				el.value = 5;
			}
			el = document.getElementById('fa916598-d222-471e-bedd-3c1ce95db3f9');
			if (el) {
				el.focus();
				el.value = 10;
			}
			el = document.getElementById('2fd63034-2a9b-4400-889d-b3af4fbd79f0');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('fc757406-1d6f-4d6d-bd33-00f1319486a3');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('feb319db-41d6-4129-889f-37e419866578');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('6b43b03c-527c-4925-be49-138eb988e490');
			if (el) {
				el.focus();
				el.value = 15;
			}
			el = document.getElementById('e8d3067d-243d-46c4-8179-61b0a777aeff');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('fd2d864a-ddcb-4856-89c2-2e7df570d537');
			if (el) {
				el.focus();
				el.value = 3;
			}
			el = document.getElementById('543665e9-8008-4837-b1fd-7a06e2f1762a');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('07a7db80-98c7-4fbe-9c7a-7a9fba1321de');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('556bc7b3-f0dd-4f4e-9319-682eb8b06ddc');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('253830c8-6365-43a8-8428-c9d4f7623854');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('abfb84ed-e919-44ca-991f-15617a42f532');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('4fd35af8-03c8-4a70-878f-d2b445b5ed55');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('6f2afdde-e6ff-4e05-a4a8-f9d9ddf58a65');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('31b6e71b-cd48-4088-b8a5-8b092cf4dfbd');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('a59a3ed0-cafd-4562-add5-2b681f1f5d5a');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('7a8100b8-92da-4ab4-bc9a-a989f6a06e13');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('b11b3f9a-61bd-4e11-9510-d0ddce4a1015');
			if (el) {
				el.focus();
				el.value = 10;
			}
			el = document.getElementById('1599ba7c-f524-4c43-a4e2-10190c73078d');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('dbbbcc22-21a3-43dc-94a7-8956534ba61d');
			if (el) {
				el.focus();
				el.value = 20;
			}
			el = document.getElementById('cf52e990-0a7c-4cf7-86bc-808335e77655');
			if (el) {
				el.focus();
				el.value = 20;
			}
			el = document.getElementById('f9a46b3a-0130-42cd-8c8e-051f135118b7');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('89ed3ee4-9eaa-40cb-a941-6c059cee5ae9');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('70289cb3-cb0b-42d1-9577-297c96702ce1');
			if (el) {
				el.focus();
				el.value = 5;
			}
			el = document.getElementById('4d4d2490-cd4e-4d0d-8ac8-473223b72409');
			if (el) {
				el.focus();
				el.value = 3;
			}
			el = document.getElementById('e7b58401-823b-4e0c-aba7-d4bb799d6448');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('0cb84b32-1520-4ff3-bcb5-2066eb6a6c2e');
			if (el) {
				el.focus();
				el.value = 12;
			}
			el = document.getElementById('aa42bc73-b055-40a1-a70d-dc3114567857');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('a5f23df2-7fbd-4d1b-994d-f0d9b5f1051b');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('c9b40d53-4aae-4cc0-8255-39f4acd302f8');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('45ecb573-22e4-4a09-991f-ef9b54832e69');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('20633421-a295-44ff-8d16-f717fa50aeee');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('a8879b0e-c52d-4c6b-9df1-19ce5135a509');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('7f5841a5-2f74-40ae-b520-5c29eb86b8d2');
			if (el) {
				el.focus();
				el.value = 8;
			}
			el = document.getElementById('7490dd36-8d84-429d-aedb-f0fd698f60e9');
			if (el) {
				el.focus();
				el.value = 4;
			}
			el = document.getElementById('34f0777d-c124-438e-a10f-15eaa9705e6b');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('OpeningShip');
			el.focus();
		} else if (tabValue === 5) {
			let el = document.getElementById('a107de53-9800-41b2-9dc4-288ae857b1af');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('2fbb5ed9-2c3d-4912-819a-7bf16ab021d9');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('946f702a-3d42-4de2-8860-c3a1d3e2c103');
			if (el) {
				el.focus();
				el.value = 3;
			}
			el = document.getElementById('c1e0fd85-4708-43cd-8ba6-0db23c0e05d5');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('87dea112-83e4-47a5-a24f-b1e38ac42a24');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('3a08e4cb-449d-41a2-948c-cb6b50cd3db8');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('6a1eccad-0a3f-4aef-a831-0c0c6f2dd868');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('2b0c8e80-f4db-4c3d-8511-c00baacb8f2b');
			if (el) {
				el.focus();
				el.value = 10;
			}
			el = document.getElementById('0e1ae5d3-2440-466c-bf7d-29315cac6cd8');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('9bf21853-45df-45fa-bbe8-6687e2e1c15f');
			if (el) {
				el.focus();
				el.value = 3;
			}
			el = document.getElementById('76111a87-26eb-485c-8d54-830c905cf380');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('86b663a6-0c21-44fe-b092-e3274abf75f9');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('21bf9efe-81d1-432d-8a04-cea7dfc5130f');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('OpeningShip');
			el.focus();
		} else if (tabValue === 3) {
			let el = document.getElementById('0b74ae67-f5af-4eec-9cec-b27814cc90cf');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('e5cafca7-9734-4806-9ce0-417b3077a93c');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('90016289-aa8a-42b3-a4fc-b94365196eea');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('cb805f27-e0b9-4060-ad6a-16aa6fa728ff');
			if (el) {
				el.focus();
				el.value = 5;
			}
			el = document.getElementById('49b17101-a773-4a47-81c1-5f1f53ddfb42');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('5f7eb633-2d68-4552-972c-5fee758df09e');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('5a07fca2-cbb3-40f0-ae9b-cf576ba210cf');
			if (el) {
				el.focus();
				el.value = 12;
			}
			el = document.getElementById('5611a266-6ce6-4865-8844-9c922b52d870');
			if (el) {
				el.focus();
				el.value = 5;
			}
			el = document.getElementById('6018c934-3d99-43e9-a376-796237f3264f');
			if (el) {
				el.focus();
				el.value = 6;
			}
			el = document.getElementById('ee24ce70-0c96-4976-bab1-efa72aa767bb');
			if (el) {
				el.focus();
				el.value = 1;
			}
			el = document.getElementById('0dddfd6c-7c33-464d-b853-3055170f92d8');
			if (el) {
				el.focus();
				el.value = 8;
			}
			el = document.getElementById('22364112-9073-46ba-8f8e-3156c4898d0e');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('1ba9914f-8caa-459e-9ff7-6b3e47d36fa4');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('OpeningShip');
			el.focus();
		} else if (tabValue === 2) {
			let el = document.getElementById('3a2b8c30-3c79-4e51-b7f3-ad6aac2abc14');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('OpeningShip');
			el.focus();
		} else if (tabValue === 1) {
			let el = document.getElementById('2e888963-5aa0-41aa-a06f-0a2053a6bf4c');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('75032ca2-147b-45f6-b2b3-2fb6d002fc27');
			if (el) {
				el.focus();
				el.value = 2;
			}
			el = document.getElementById('OpeningShip');
			el.focus();
		}
	};

	const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

	const handleInput = (e) => setInput(e.target.value);

	const handleReset = () => navigate('/dashboard');

	async function createOrder() {
		let created;
		if (location.state) {
			if (location.state.length > 0) {
				updateOrder(formState.code, formState.name, formState.qty, formState.amount, 'TW');
			}
		} else {
			try {
				const variables = {
					Code: formState.code,
					Name: formState.name,
					Qty: formState.qty,
					Amount: formState.amount,
					Status: formState.status,
					OrderType: 'TW'
				};
				created = await createOverseasOrder(variables);
				created = created.data.createOverseasOrder;
			} catch (error) {
				console.log('error', error);
			}

			let data = [];
			let shipFrom = '';
			for (let i in inv) {
				let code = inv[i].Code;
				shipFrom = inv[i].ShipFrom;
				let iqty = qtyVal[i].Qty;
				let iprice = JSON.parse(inv[i].Price)[curArea];
				if (code === qtyVal[i].Code) {
					if (qtyVal[i].Qty > 0) {
						let cSize = inv[i].CartonSize ? inv[i].CartonSize.split('*') : 0;
						data.push({
							Category: inv[i].Category,
							ProductName: inv[i].Product,
							Code: inv[i].Code,
							UnitPrice: iprice,
							OrderingQty: iqty,
							Amount: Math.round(iprice * iqty * 100) / 100,
							ProductZH: inv[i].ZH,
							PackagingSize: inv[i].Size,
							ExpiryDate: inv[i].Expiry !== null ? inv[i].Expiry + 'months' : 'N/A',
							Unit: inv[i].Unit,
							NW: inv[i].NW,
							TotalNetWeight: inv[i].NW * parseInt(iqty) || '',
							GW: inv[i].GW,
							TotalGrossWeight: inv[i].GW * parseInt(iqty) || '',
							CBM: cSize === 0 ? '' : Math.round(((cSize[0] * cSize[1] * cSize[2] * iqty) / 1000000) * 100) / 100,
							CartonSize: inv[i].CartonSize,
							Note: inv[i].Note,
							OrderArea: curArea
						});
					}
				}
			}
			const fileType = 'application/vnd.openxmIformats-officedocument .spreadsheetml. sheet; charset-UTF-8';
			const fileExtension = '.xlsx';
			const borderStyle = { border: { bottom: { style: 'thick', color: '000000' } } };
			let sum = 0;
			qtyVal.map((item) => (item.Qty > 0 ? (sum += item.Price) : 0));
			exportToExcel(
				data,
				new Date().toISOString(),
				curQty,
				sum,
				company[curArea],
				fileType,
				fileExtension,
				borderStyle,
				'fileName',
				'buffer'
			).then(async (res) => {
				sendMail(
					getname,
					companyEmail[curArea],
					company[curArea],
					curQty,
					curCount,
					sum,
					curArea,
					qtyVal,
					shipFrom,
					res,
					created.id.split('-')[0],
					'create'
				);
			});
		}
		updateFormState(initialState);
	}

	async function getItem(areaVal) {
		try {
			const posts = await listShippings([{ ShipFrom: { eq: 'TW' } }, { Area: { contains: areaVal } }]);
			let userInv = [];
			let val = [];
			let oval = location.state;
			let index = -1;
			posts.sort(function (a, b) {
				if (a.Code < b.Code) {
					return -1;
				}
				if (a.Code > b.Code) {
					return 1;
				}
				return 0;
			});
			for (let i in posts) {
				if (posts[i] !== undefined) {
					if (posts[i].Area.includes(areaVal)) {
						val.push({
							id: posts[i].id,
							Code: posts[i].Code,
							Qty: 0,
							Price: JSON.parse(posts[i].Price)[areaVal],
							Product: posts[i].Product,
							Category: posts[i].Category,
							Expiry: posts[i].Expiry,
							Unit: posts[i].Unit,
							Size: posts[i].Size,
							ZH: posts[i].ZH,
							Moq: posts[i].Moq,
							Error: false,
							Nw: posts[i].NW,
							Gw: posts[i].GW,
							CBM: 0,
							CartonSize: posts[i].CartonSize || '0*0*0',
							Img: posts[i].Img,
							index: (index += 1)
						});
						userInv.push(posts[i]);
					}
				}
			}
			let newQt = 0;
			let newCount = 0;
			let newCbm = 0;
			let fa = 0;
			for (let o in oval) {
				for (let v in val) {
					if (val[v].Code === oval[o].Code) {
						let cSize = oval[o].CartonSize ? oval[o].CartonSize.split('*') : 0;
						val[v].Qty = parseInt(oval[o].OrderingQty);
						newQt += parseInt(val[v].Qty);
						newCount += 1;
						val[v].CBM =
							(parseInt(val[v].Qty) * (parseInt(cSize[0]) * parseInt(cSize[1]) * parseInt(cSize[2]))) / 1000000;
						newCbm += val[v].CBM || 0;
						val[v].Nw = oval[o].Nw * parseInt(val[v].Qty);
						val[v].Price = val[v].Qty * val[v].Price;
						fa += val[v].Price;
					}
				}
			}
			updateItem(userInv);
			updateVal(val);
			setCurQty(newQt);
			setCurCount(newCount);
			setFinalAmount(fa);
			setCBM(newCbm.toFixed(2));
			let cat = {};
			val
				.map((item) => item.Category)
				.map((item) => {
					return (cat[item] = 0);
				});
			val.map((item) => {
				if (item.Qty > 0) {
					cat[item.Category] += 1;
				}
				return '';
			});
			setCatCount(cat);

			let catQuantity = {};
			val
				.map((item) => item.Category)
				.map((item) => {
					return (catQuantity[item] = 0);
				});
			val.map((item) => {
				if (item.Qty > 0) {
					catQuantity[item.Category] += parseInt(item.Qty);
				}
				return '';
			});
			setCatQty(catQuantity);

			let catFa = {};
			val
				.map((item) => item.Category)
				.map((item) => {
					return (catFa[item] = 0);
				});
			val.map((item) => {
				if (item.Qty > 0) {
					catFa[item.Category] += item.Price;
				}

				return '';
			});
			setCatAmount(catFa);
		} catch (error) {
			console.log('Error retrieving inv', error);
		}
	}

	function onChange(e, index) {
		let val = parseInt(e.target.value);
		let newVal = [...qtyVal];
		newVal[index].Price = val * JSON.parse(inv[index].Price)[curArea] || JSON.parse(inv[index].Price)[curArea];
		newVal[index].Qty = val || 0;
	}

	function onBlur(e, index, moq) {
		let newCount = 0;
		let catFa = {};
		let catQuantity = {};
		let newQty = 0;
		let val = parseInt(e.target.value) || 0;
		let min = moq[0];
		let max = moq[moq.length - 1];
		let newVal = [...qtyVal];
		let newPrice = JSON.parse(inv[index].Price)[curArea];
		let cat = {};
		let fa = 0;
		let newCbm = 0;
		let cSize = inv[index].CartonSize ? inv[index].CartonSize.split('*') : 0;
		newVal
			.map((item) => item.Category)
			.map((item) => {
				return (cat[item] = 0);
			});
		newVal
			.map((item) => item.Category)
			.map((item) => {
				return (catQuantity[item] = 0);
			});
		newVal
			.map((item) => item.Category)
			.map((item) => {
				return (catFa[item] = 0);
			});

		if (val > max || val < min) {
			newVal[index].Error = true;
			newVal[index].Price = newPrice;
			newVal[index].Qty = 0;
			newVal[index].CBM = 0;
		} else {
			newVal[index].Price = val * JSON.parse(inv[index].Price)[curArea] || newPrice;
			newVal[index].Qty = val;
			newVal[index].Error = false;
			newVal[index].CBM =
				parseInt(newVal[index].Qty * parseInt(cSize[0]) * parseInt(cSize[1]) * parseInt(cSize[2])) / 1000000;
		}

		qtyVal.map((item, i) => {
			if (item.Qty > 0 && item.Qty <= max) {
				cSize = item.CartonSize ? item.CartonSize.split('*') : 0;
				newQty += parseInt(item.Qty);
				newCount += 1;
				cat[item.Category] += 1;
				catQuantity[item.Category] += parseInt(item.Qty);
				catFa[item.Category] += item.Price;
				fa += item.Qty * JSON.parse(inv[i].Price)[curArea];
				newCbm += parseInt(item.Qty * parseInt(cSize[0]) * parseInt(cSize[1]) * parseInt(cSize[2])) / 1000000;
			}
			return newQty;
		});
		setCurQty(newQty);
		setCurCount(newCount);
		updateVal(newVal);
		setCatCount(cat);
		setCatQty(catQuantity);
		setCatAmount(catFa);
		setFinalAmount(fa);
		setCBM(newCbm.toFixed(2));
	}

	function CustomTabPanel(props) {
		const { children, value, index, ...other } = props;
		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}>
				{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
			</div>
		);
	}

	CustomTabPanel.propTypes = {
		children: PropTypes.node,
		index: PropTypes.number.isRequired,
		value: PropTypes.number.isRequired
	};

	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			'aria-controls': `simple-tabpanel-${index}`
		};
	}

	const OrderCard = (ival) =>
		[ival.val].map((item, index) => {
			const imgUrl = item.Img ? item.Img : 'products/img/5.png';
			const imgTitle = item.Img ? item.Product : 'Working on photo';
			const imgSrc = `https://macuglobal82751-staging.s3.ap-southeast-1.amazonaws.com/public/${imgUrl}`;
			return (
				<Card sx={{ border: '#eaeaea 0.1px solid' }} key={item.Product + index}>
					<Box
						sx={{ cursor: item.Img && 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
						onClick={(e) => item.Img && handleDialog(e, imgTitle, imgSrc)}>
						<CardMedia sx={{ height: '20vh', width: '60%' }} image={imgSrc} title={imgTitle} />
					</Box>
					<CardContent sx={{ height: 200, paddingBottom: 0 }}>
						<Tooltip title={t('order.Code')}>
							<SoftTypography variant="caption" fontWeight="regular" color="text">
								<SoftBadge variant="gradient" badgeContent={item.Code} color="light" size="xs" container />
								&nbsp;
							</SoftTypography>
						</Tooltip>
						{item.Expiry > 0 ? (
							<Tooltip title={t('order.Expiry')}>
								<SoftTypography variant="caption" fontWeight="regular" color="text">
									<SoftBadge
										variant="gradient"
										badgeContent={item.Expiry + t('order.Month')}
										color="secondary"
										size="xs"
										container
									/>
									&nbsp;
								</SoftTypography>
							</Tooltip>
						) : null}
						{item.Unit ? (
							<Tooltip title={t('order.Unit')}>
								<SoftTypography variant="caption" fontWeight="regular" color="text">
									<SoftBadge variant="gradient" badgeContent={item.Unit} color="dark" size="xs" container />
								</SoftTypography>
							</Tooltip>
						) : null}
						<SoftTypography pt={2} variant="h6" fontWeight="medium">
							{item.Product.charAt(0) + item.Product.toLowerCase().slice(1)}
							<br />
							{item.ZH}
						</SoftTypography>
						<SoftTypography variant="h6" fontWeight="regular" color="text">
							{t('order.Size')}:&nbsp;{item.Size}
						</SoftTypography>
						<SoftTypography pt={2} variant="h6" fontWeight="medium">
							${item.Price.toLocaleString(undefined, { minimumFractionDigits: 2 })}
						</SoftTypography>
					</CardContent>
					<CardActions>
						<FormControl fullWidth variant="outlined" sx={{ paddingLeft: 2, paddingRight: 2 }}>
							{item.Moq.length > 2 ? (
								<>
									<Select
										defaultValue={item.Qty}
										onChange={(e) => onChange(e, ival.catindex)}
										onBlur={(e) => onBlur(e, ival.catindex, item.Moq)}>
										<MenuItem value={0}>0</MenuItem>
										{item.Moq.map((val) => {
											return (
												<MenuItem key={item.Product + val} value={val}>
													{val}
												</MenuItem>
											);
										})}
									</Select>
								</>
							) : (
								<>
									<SoftInput
										variant="standard"
										error={item.Error}
										type="number"
										defaultValue={item.Qty}
										id={item.id}
										onChange={(e) => onChange(e, ival.catindex)}
										onFocus={(e) => e.target.select()}
										onBlur={(e) => onBlur(e, ival.catindex, item.Moq)}
									/>
									<FormHelperText
										sx={{ marginLeft: 0 }}
										error={item.Error}
										id="outlined-weight-helper-msg"
										hidden={!item.Error}>
										{item.Moq[0] + ' <= ' + t('Quantity') + ' <= ' + item.Moq[item.Moq.length - 1]}
									</FormHelperText>
								</>
							)}
							<FormHelperText sx={{ marginLeft: 0 }} id="outlined-weight-helper-text">
								{t('order.Moq')} {item.Moq[0]} - {item.Moq[item.Moq.length - 1]}/{item.Unit}
							</FormHelperText>
						</FormControl>
					</CardActions>
				</Card>
			);
		});

	function ReviewCard() {
		let added = [];
		qtyVal.map((item) => {
			if (item.Qty > 0) {
				added.push(item);
			}
			return '';
		});
		return [...new Set(added.map((item) => item.Category))].map((category, catIndex) => (
			<div key={category + catIndex}>
				<SoftBox pt={2} px={2}>
					<Grid container spacing={3}>
						<Grid item xs>
							<SoftTypography variant="h6" fontWeight="bold">
								{category}
							</SoftTypography>
						</Grid>
						<Grid item xs>
							<SoftTypography variant="h6" fontWeight="bold">
								{catQty[category]}
							</SoftTypography>
						</Grid>
						<Grid item xs>
							<SoftTypography variant="h6" fontWeight="bold">
								${catAmount[category].toLocaleString(undefined, { minimumFractionDigits: 2 })}
							</SoftTypography>
						</Grid>
					</Grid>
				</SoftBox>
				<Divider />
				{added
					.filter((item) => item.Category === category)
					.map((item, index) => (
						<SoftBox
							component="li"
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							key={item.Product + index}
							mb={false ? 0 : 1}
							pt={2}
							px={2}
							pb={2}>
							<Grid container spacing={3}>
								<Grid item xs>
									<SoftTypography display="block" variant="h6" fontWeight="regular">
										{item.Product.charAt(0) + item.Product.toLowerCase().slice(1)}
										<br />
										{item.ZH}
									</SoftTypography>
								</Grid>
								<Grid item xs>
									<SoftTypography variant="h6" fontWeight="regular">
										{item.Qty}
									</SoftTypography>
								</Grid>
								<Grid item xs>
									<SoftTypography variant="h6" fontWeight="regular">
										${item.Price.toLocaleString(undefined, { minimumFractionDigits: 2 })}
									</SoftTypography>
								</Grid>
							</Grid>
						</SoftBox>
					))}
			</div>
		));
	}

	function sumCard() {
		let sum = 0;
		qtyVal.map((item) => (item.Qty > 0 ? (sum += item.Price) : 0));
		return '$' + sum.toLocaleString(undefined, { minimumFractionDigits: 2 });
	}

	function submit() {
		let val = [];
		let userArea = getname + '@' + curArea;
		let qty = 0;
		let amount = 0;
		for (let q in qtyVal) {
			if (qtyVal[q].Qty > 0) {
				val.push(qtyVal[q].Code + '@' + qtyVal[q].Qty + '@' + parseFloat(qtyVal[q].Price.toFixed(2)));
				qty += parseInt(qtyVal[q].Qty);
				amount += qtyVal[q].Price; //parseFloat(qtyVal[q].Price.toFixed(2));
			}
		}
		updateFormState({
			code: val,
			name: userArea,
			qty: qty,
			amount: parseFloat(amount),
			status: ['pending@' + new Date().toISOString()]
		});
	}

	async function updateOrder(val, name, qty, amount) {
		try {
			const original = await getOrder(location.state[0].orderid);
			const variables = {
				id: original.id,
				_version: original._version,
				Code: val,
				Name: name,
				Qty: qty,
				Amount: amount,
				Status: [...original.Status, 'pending@' + new Date().toISOString()]
			};
			await updateOverseasOrder(variables);
		} catch (error) {
			console.log('error', error);
		}
		let shipFrom = '';
		let data = [];
		for (let i in inv) {
			let code = inv[i].Code;
			shipFrom = inv[i].ShipFrom;
			let iqty = qtyVal[i].Qty;
			let iprice = JSON.parse(inv[i].Price)[curArea];
			if (code === qtyVal[i].Code) {
				if (qtyVal[i].Qty > 0) {
					let cSize = inv[i].CartonSize ? inv[i].CartonSize.split('*') : 0;
					data.push({
						Category: inv[i].Category,
						ProductName: inv[i].Product,
						Code: inv[i].Code,
						UnitPrice: iprice,
						OrderingQty: iqty,
						Amount: Math.round(iprice * iqty * 100) / 100,
						ProductZH: inv[i].ZH,
						PackagingSize: inv[i].Size,
						ExpiryDate: inv[i].Expiry !== null ? inv[i].Expiry + 'months' : 'N/A',
						Unit: inv[i].Unit,
						NW: inv[i].NW,
						TotalNetWeight: inv[i].NW * parseInt(iqty) || '',
						GW: inv[i].GW,
						TotalGrossWeight: inv[i].GW * parseInt(iqty) || '',
						CBM: cSize === 0 ? '' : Math.round(((cSize[0] * cSize[1] * cSize[2] * iqty) / 1000000) * 100) / 100,
						CartonSize: inv[i].CartonSize,
						Note: inv[i].Note,
						OrderArea: curArea
					});
				}
			}
		}
		const fileType = 'application/vnd.openxmIformats-officedocument .spreadsheetml. sheet; charset-UTF-8';
		const fileExtension = '.xlsx';
		const borderStyle = { border: { bottom: { style: 'thick', color: '000000' } } };
		let sum = 0;
		qtyVal.map((item) => (item.Qty > 0 ? (sum += item.Price) : 0));
		exportToExcel(
			data,
			new Date().toISOString(),
			curQty,
			sum,
			company[curArea],
			fileType,
			fileExtension,
			borderStyle,
			'fileName',
			'buffer'
		).then(async (res) => {
			sendMail(
				getname,
				companyEmail[curArea],
				company[curArea],
				curQty,
				curCount,
				sum,
				curArea,
				qtyVal,
				shipFrom,
				res,
				location.state[0].orderid.split('-')[0],
				'update'
			);
		});
	}

	function FetchProducts(searchstring) {
		// eslint-disable-next-line
		const filteredList = qtyVal.filter((element) => {
			if (searchstring.val.length > 0) {
				for (let j in searchstring) {
					if (element.Product.includes(searchstring[j].toUpperCase())) {
						return element;
					}
				}
			}
		});
		return filteredList.map((item) => (
			<Grid item xs={12} md={4}>
				<OrderCard val={item} catindex={item.index} key={item + item.index} />
			</Grid>
		));
	}

	function searchTab() {
		return (
			<SoftBox className="App" spacing={3} sx={{ width: '100%' }}>
				<Autocomplete
					id="combo-box-demo"
					sx={{ width: 300 }}
					defaultValue={input}
					options={qtyVal.map((item) => item.Product.charAt(0) + item.Product.toLowerCase().slice(1))}
					renderInput={(params) => (
						<TextField {...params} variant="outlined" placeholder="Search Item" onBlur={handleInput} />
					)}
				/>
				<Grid container spacing={2} paddingTop={2}>
					<FetchProducts val={input} />
				</Grid>
			</SoftBox>
		);
	}

	return (
		<>
			<SoftBox py={3}>
				<SoftBox mb={3}>
					<Card>
						<SoftBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
							<SoftTypography variant="h5" fontWeight="bold">
								{t('order.New order')}
							</SoftTypography>
							{location.state ? null : role !== 'Owner' && area.length > 1 ? (
								<Autocomplete
									disablePortal
									id="select-area"
									value={curArea}
									options={area.map((a) => a)}
									sx={{ width: 300 }}
									onChange={handleChange}
									renderInput={(params) => <TextField {...params} placeholder={t('area.Please select the area')} />}
								/>
							) : null}
						</SoftBox>
						<SoftBox
							sx={{
								'& .MuiTableRow-root:not(:last-child)': {
									'& td': {
										borderBottom: ({ borders: { borderWidth, borderColor } }) =>
											`${borderWidth[1]} solid ${borderColor}`
									}
								}
							}}>
							<Stepper activeStep={activeStep}>
								{steps.map((label) => {
									const stepProps = {};
									const labelProps = {};
									return (
										<Step key={label} {...stepProps}>
											<StepLabel {...labelProps}>{t('order.' + label)}</StepLabel>
										</Step>
									);
								})}
							</Stepper>
							<SoftTypography px={2} variant="h6" fontWeight="bold">
								{' '}
								{t('order.Currency')}: {currency}, CBM: {curCBM}
							</SoftTypography>
							{(() => {
								if (activeStep === steps.length - 1) {
									return (
										<div>
											<SoftBox p={2} mx={3} display="flex" justifyContent="center">
												<SoftBox
													display="grid"
													justifyContent="center"
													alignItems="center"
													color="green"
													width="4rem"
													height="4rem">
													<Icon fontSize="large">check_circle</Icon>
												</SoftBox>
											</SoftBox>
											<SoftBox pb={6} px={2} pt={6} textAlign="center" lineHeight={1.25}>
												<SoftTypography variant="h6" fontWeight="bold">
													{t('order.Done')}
												</SoftTypography>
												<br />
												<SoftTypography variant="h6" color="text" fontWeight="bold">
													{t('order.Order created')}
												</SoftTypography>
												<SoftTypography variant="caption" color="text" fontWeight="regular">
													{t('Order Created')}
												</SoftTypography>
												<Divider />
												<SoftButton onClick={handleReset}>{t('order.View order')}</SoftButton>
											</SoftBox>
										</div>
									);
								} else if (activeStep === 0) {
									return (
										<div>
											<SoftBox pt={2} px={2}>
												<Grid container spacing={3}>
													<Grid item xs={12} md={9}>
														<SoftTypography variant="h6" color="text" fontWeight="bold">
															{t('Item')}: {curCount}, {t('order.Total quantity')}: {curQty.toLocaleString()},{' '}
															{t('Total amount')}: $
															{finalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
														</SoftTypography>
													</Grid>
													<Grid item xs={12} md={3} display="flex" justifyContent="flex-end">
														{['Overseas', 'MACU_Trade'].includes(getname) ? (
															<SoftButton
																id="OpeningShip"
																variant="contained"
																color="secondary"
																onClick={handleOpening}>
																Initial-Order
															</SoftButton>
														) : null}
														<SoftButton
															variant="contained"
															color="secondary"
															onClick={handleNext}
															disabled={curQty === 0}>
															{t('order.Next')}
														</SoftButton>
													</Grid>
												</Grid>
											</SoftBox>
											<SoftBox>
												<Tabs
													value={tabValue}
													onChange={handleSetTabValue}
													variant="scrollable"
													scrollButtons
													allowScrollButtonsMobile>
													<Tab
														icon={<SearchIcon />}
														iconPosition="end"
														label="Search"
														fontSize="large"
														key={'searchbtn'}
														{...a11yProps(0)}
													/>
													{[...new Set(qtyVal.map((item) => item.Category))].map((item, index) => (
														<Tab
															label={
																<span>
																	{item}&nbsp;
																	{catCount[item] > 0 ? (
																		<SoftBadge
																			variant="gradient"
																			circular
																			badgeContent={catCount[item]}
																			color="light"
																			size="xs"
																			container
																		/>
																	) : null}
																</span>
															}
															key={item + 'fbtn'}
															{...a11yProps(index)}
														/>
													))}
												</Tabs>
											</SoftBox>
											<CustomTabPanel value={tabValue} index={0} key={'panel-search'}>
												{searchTab()}
											</CustomTabPanel>
											<Grid container>
												{qtyVal.map((cat, catindex) =>
													[cat]
														.filter(
															(item) =>
																item.Category === [...new Set(qtyVal.map((item) => item.Category))][tabValue - 1]
														)
														.map((item, index) => (
															<Grid item xs={12} md={4} key={item + 'cat' + index}>
																<CustomTabPanel value={tabValue} index={tabValue} key={item + 'panel' + index}>
																	<OrderCard val={item} catindex={catindex} />
																</CustomTabPanel>
															</Grid>
														))
												)}
											</Grid>
										</div>
									);
								} else {
									return (
										<div>
											<Box
												component="li"
												display="flex"
												justifyContent="space-between"
												alignItems="center"
												mb={false ? 0 : 1}
												pt={2}
												px={2}>
												<SoftButton onClick={handleBack} sx={{ mr: 1 }}>
													{t('order.Back')}
												</SoftButton>
												<Box sx={{ flex: '1 1 auto' }} />
												<SoftButton variant="contained" color="success" onClick={handleNext}>
													{location.state ? t('order.Update') : t('order.Create')}
												</SoftButton>
											</Box>
											<SoftBox
												component="li"
												display="flex"
												justifyContent="space-between"
												alignItems="center"
												mb={false ? 0 : 1}
												pt={2}
												px={2}>
												<Grid container spacing={3}>
													<Grid item xs>
														<SoftTypography display="block" variant="h6" fontWeight="bold">
															{t('Item')} ({curCount})
														</SoftTypography>
													</Grid>
													<Grid item xs>
														<SoftTypography variant="h6" fontWeight="bold">
															{t('Quantity')} ({curQty})
														</SoftTypography>
													</Grid>
													<Grid item xs>
														<SoftTypography variant="h6" fontWeight="bold">
															{t('Price')} ({sumCard()})
														</SoftTypography>
													</Grid>
												</Grid>
											</SoftBox>
											<ReviewCard />
										</div>
									);
								}
							})()}
						</SoftBox>
					</Card>
				</SoftBox>
			</SoftBox>
			<Dialog dialog={dialog} title={dTitle} content={dContent} handleClose={handleDialog} showBtn={false} />
		</>
	);
};

// const customStyles = {
//   content: {
//     top: '50%',
//     left: '50%',
//     right: 'auto',
//     bottom: 'auto',
//     marginRight: '-50%',
//     transform: 'translate(-50%, -50%)',
//   },
// };

export default Order;
